// extracted by mini-css-extract-plugin
export default {"container":"MenuItem_container__DeuRY","title":"MenuItem_title__WyyKr"};